import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { ajax } from "jquery";
import ContentTitle from '../../components/common/container/title';
import ElementMessage from '../../components/common/elementmessage';
import Button from '../../components/forms/button';
import InlineData from '../../components/forms/inlinedata'
import "react-datepicker/dist/react-datepicker.css";
import DatePicker, { registerLocale } from 'react-datepicker';
import Translate from '../../components/common/translate'
import Utils from '../../helpers/utils';
import * as CONST from '../../helpers/const';
import ja from "date-fns/locale/ja";
import ICA0111Table from './ica0111-table';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

var jaLocale = {
    ...ja,
    options: {
        weekStartsOn: 0, firstWeekContainsDate: 1
    }
}
registerLocale('ja', jaLocale);
const getTranslateValue = Utils.getTranslateValue;

const API = {
    REGISTER: window.domainDir + "api/Billing/RegisterBillingRequest"
}

const URLPath = {
    IAC0101: "/Cart/ConfirmFacilityInfo",
}

const ICA0111_Master = (props) => {
    let translate = useRef(null);
    let history = useHistory();

    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [requestId, setRequestId] = useState("");
    const [referencepassword, setReferencePassword] = useState("");
    const [translateSuccess, setTranslateSuccess] = useState(false);
    // states for table
    const [cartList, setCartList] = useState([]);
    const [facilityInfo, setFacilityInfo] = useState(null);
    const [currentPage, setPageNo] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [isFetching, setLoadingState] = useState(false);
    const [screenLoaded, setScreenLoaded]  = useState(false);
    const [initialData, setInitialData] = useState(null);

    const [facilityName, setFacilityName] = useState("");
    const [address1, setAddress1] = useState("");
    const [address2, setAddress2] = useState("");
    const [address3, setAddress3] = useState("");
    const [tel, setTel] = useState("");
    const [mobile, setMobile] = useState("");
    const [zipNo, setZipNo] = useState("");
    const [email, setEmail] = useState("");
    const [iraidetails, setIraiDetails] = useState([]);
    const [apiResponse, setApiResponse] = useState(null);

    useEffect(() => {
        $("#loading").fadeIn();
        getItemsFromCart();
        getFacilityInfo();
        setScreenLoaded(true);
        $("#loading").fadeOut();
    }, []);

    function clearMessage() {
        setStatus("");
        setMessage("");
    }

    function setStatusMessage(status, message) {
        Utils.scrollToTop();
        setStatus(status);
        setMessage(message);
    }

    function getItemsFromCart(){
        var sessionCart = sessionStorage.getItem('sessionCart');
        if(null != sessionCart){
            setCartList(JSON.parse(sessionCart));
        }
    }
  
    function getFacilityInfo() {
        var sessionInfo = sessionStorage.getItem('facilityinfo');
        if(null != sessionInfo){
            setFacilityInfo(JSON.parse(sessionInfo));
        }
    }

    function handleRedirect(path) {
        if (typeof path === 'string' || path instanceof String) {
            history.push(path);
        }
    }

    function handleNewIrai() {
        clearMessage();
        $("#loading").fadeIn();
        var model = getFormData();
        sessionStorage.setItem('bbmedical_billingcomplete', true);
        ajax({url: API.REGISTER,
            type: 'POST',
            data: JSON.stringify(model),
            contentType: 'application/json; charset=utf-8',
            credentials: 'same-origin',
            dataType: "JSON"
        }).done(json => {
            let result = json;
            if (result.Status === CONST.ApiResult.Success) {
                setStatusMessage(CONST.ApiResult.Success, result.Message);
                setCartList([]);
                sessionStorage.removeItem("sessionCart");
                
                const billingDtlModel = result.Response;
                sessionStorage.setItem("bbmedical_iraino", billingDtlModel.IraiNo);
                sessionStorage.setItem("bbmedical_showpassword", billingDtlModel.ShowPassword);

                history.push(`/Billing/Details`);
            } else {
                setStatusMessage(CONST.ApiResult.Error, result.Message);
            }
        }).fail(json => {
            setStatusMessage(CONST.ApiResult.Error, getTranslateValue(translate.current, "messages.common.exceptionerror"));
        }).always(json => {
            $("#loading").fadeOut();
        });
    }

    function getFormData() {
        let model = {};
        const info = facilityInfo ? facilityInfo : {};
        const list = cartList ? cartList : [];
        model.Irai = {
            ZipNo: info.PostalCode || "",
            Address1: info.Address1 || "",
            Address2: "",
            Address3: "",
            Todofuken: info.Todofuken || "",
            IraiFacilityName: info.FacilityName || "",
            IraiDepartmentName: info.DepartmentName || "",
            Tel: info.PhoneNumber || "",
            Mobile: info.Mobile || "",
            Email: info.Email || "",
            Fax: info.Fax || "",
            IraishaName: `${info.KanjiLastName || ""} ${info.KanjiFirstName || ""}`.trim(),
            IraishaNameKana: `${info.KanaLastName || ""} ${info.KanaFirstName || ""}`.trim(),
            EntryDt: new Date(),
            UpdateDt: new Date(),
            DeleteFlg: false
        };

        model.IraiDetails = list.map(function(item) {
            return {
                HansokuId: item.HansokuId || null,
                HansokuCode: item.HansokuCode || "",
                HansokuName: item.HansokuName || "",
                IraiQt: item.IraiQt || 0
            };
        });

        return model;
    }

    function renderFacilityInformationForm() {
        return (
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.shared.facilityinformation")}</legend>
                <InlineData
                    label={getTranslateValue(translate.current, "views.ica0111.postalcode")}
                    name="postalcode"
                    value={facilityInfo.PostalCode}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.ica0111.address")}
                    name="address"
                    value={facilityInfo.Address}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.ica0111.facilityname")}
                    name="facilityname"
                    value={facilityInfo.FacilityName}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.ica0111.phonenumber")}
                    name="phonenumber"
                    value={facilityInfo.PhoneNumber}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                    containerType={"label"}
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.ica0111.fax")}
                    name="fax"
                    value={facilityInfo.Fax}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                    containerType={"label"}
                />
            </div>
        )
    }

    function renderClientInformation() {
        return (
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.shared.facilityinformation")}</legend>
                <InlineData
                    label={getTranslateValue(translate.current, "views.ica0111.namekanji")}
                    name="namekanji"
                    value={`${facilityInfo.KanjiLastName} ${facilityInfo.KanjiFirstName}`}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.ica0111.namekana")}
                    name="namekana"
                    value={`${facilityInfo.KanaLastName} ${facilityInfo.KanaFirstName}`}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.ica0111.emailaddress")}
                    name="emailaddress"
                    value={facilityInfo.Email}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                />
                <InlineData
                    label={getTranslateValue(translate.current, "views.ica0111.departmentname")}
                    name="departmentname"
                    value={facilityInfo.DepartmentName}
                    containerType={"label"}
                    inputClass= {isMobile? "col-xs-12 input-group-text": null }
                    style={ isMobile ? { paddingLeft: "15px", overflowWrap: "break-word", whiteSpace: "pre-wrap", textAlign: "left"} : undefined}
                />
            </div>
        )
    }

    function renderForm() {
        return(
            screenLoaded && (
                <div>
                    {renderFacilityInformationForm()}
                    {renderClientInformation()}
                </div>
            )
        )
    }

    function renderTable() {
        return(
            <div>
                <legend className="legend-hdr">{getTranslateValue(translate.current, "views.shared.materialstodeliver")}</legend>
                {screenLoaded && (
                <ICA0111Table 
                    data={cartList}
                    pageNo={currentPage}
                    sizePerPage={sizePerPage}
                    isFetching={isFetching}
                    translate={translate}
                    setPageNo={setPageNo.bind(this)}
                    setSizePerPage={setSizePerPage.bind(this)}
                    getTranslateValue={getTranslateValue.bind(this)}
                />
                )}
            </div>
        )
    }

    function renderActionButtons() {
        return (
            <div className="row form-group" style={{ marginTop: 10 }}>
                <div className="col-xs-4 text-left">
                    <Button color="Default" divClassName="" divStyle={{ width: '100%' }} style={{ width: 140 }} label={getTranslateValue(translate.current, "views.buttontext.return")} onClick={handleRedirect.bind(this, URLPath.IAC0101)} />
                </div>
                <div className={isMobile ? "col-xs-8 text-right" : "col-xs-4 text-center"}>
                    <Button color="Success" divClassName="" divStyle={{ width: '100%' }} style={{ width: 140 }} label={getTranslateValue(translate.current, "views.ica0111.request")} onClick={handleNewIrai.bind(this)}/>
                </div>
                {!isMobile && <div className="col-xs-4" />}
            </div>
        );
    }

    return (
        <Translate ref={translate} handlerLoad={setTranslateSuccess.bind(this, true)}>
            <ContentTitle active="#ICA0111" title={getTranslateValue(translate.current, "views.titleText.ica0111")} />
            <div className="row form-group" style={{ marginTop: 10 }}>
                <div className="col-xs-4 text-left">
                    <Button color="Default" divClassName="" divStyle={{ width: '100%' }} style={{ width: 140 }} label={getTranslateValue(translate.current, "views.buttontext.return")} onClick={handleRedirect.bind(this, URLPath.IAC0101)} />
                </div>
            </div>
            {renderForm()}
            {renderTable()}
            {renderActionButtons()}
        </Translate>
    )
}

export default ICA0111_Master;


// WEBPACK FOOTER //
// ./view/ICA0111/ica0111.jsx